'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowRightThick = function TiArrowRightThick(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.6 11c-1.3 1.3-1.3 3.4 0 4.7l2.7 2.6h-12.1c-1.8 0-3.3 1.5-3.3 3.4 0 1.8 1.5 3.3 3.3 3.3h12.1l-2.7 2.6c-1.3 1.3-1.3 3.5 0 4.8 0.7 0.6 1.5 0.9 2.4 0.9s1.7-0.3 2.4-0.9l10.6-10.7-10.6-10.7c-1.3-1.3-3.5-1.3-4.8 0z' })
        )
    );
};

exports.default = TiArrowRightThick;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-right-thick.js
// module id = 2986
// module chunks = 0